<template>
  <div class="lxn-w100 lxn-h100">
    <div class="AutoThreewaySwitchWidget-wrapper-switch lxn-margin-auto">

      <div v-for="(sw, index) in getSwitches" :key="index" class="AutoThreewaySwitchWidget-output-wrapper">
        <div class="lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-body halfHeight">
            <div @click="setButtonStatus(sw)" class="lxn-w100 lxn-h100 row align-items-center">

              <div class="lxn-w100 lxn-h100">
                <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                  <SingleThreeWaySwitch :state="getButtonState(sw)" :widgeetMode="getButtonAuto(sw)" bgColorOn="#00AEEF" bgColorOff="#ACB8BF"
                                        bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
                </div>
                <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text" :style="'color: ' + getButtonColorText(sw)"
                     :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                  {{ getButtonText(sw) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoThreewaySwitch from '@/components/AutoThreewaySwitch.vue';
import * as CONFIGS from '@/statics/configs.js';
import NODE2 from '@/statics/devices/Node2/header.js';
import NODE5 from '@/statics/devices/Node5/header.js';
import Logger from '@/statics/logger.js';
import Messaging from '@/statics/messaging.js';
import ButtonIcon from "@/components/ButtonIcon.vue";
import NODES from "@/statics/devices/Nodes";
import SingleThreewaySwitch from '@/components/SingleThreewaySwitch.vue'
import NODE13 from "@/statics/devices/Node13/header";

export default {
  name: 'AutoThreewaySwitchWidget',
  props: {
    index: Number
  },
  components: {
    ButtonIcon,
    SingleThreeWaySwitch: SingleThreewaySwitch,
  },
  mounted: function () {
    this.switches = this.widget.settings?.switches;
    this.switches.forEach((x, i) => x.name = this.node.settings.switches.find(s => s.index === x.index)?.name || (this.$store.getters.language.texts.Node2Settings_title + " " + (i + 1)));
  },
  data: function () {
    return {
      switchLocked: false,
      switchStatus: 0,
      switches: []
    }
  },
  computed: {
    getSwitches: function (){
      return this.switches;
    },
    nodeHeader: function () {
      if (this.node.deviceType == 2) {
        return NODE2;
      } else {
        return NODE13;
      }
    },
    widget: function () {
      return this.$store.state.widgets[this.index];
    },
    widgetOutputs: function () {
      return [0, 1, 2];
    },
    timeDelay: function () {
      return this.widget.timeDelay;
    },
    widgetColor: function () {
      return this.$store.state.themeMainColors[this.widget.color];
    },
    node: function () {
      return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    isNodeOffline: function () {
      if (this.node.connectionStatus == 1) {
        return false;
      } else {
        return true;
      }
    },
    isHubOffline: function () {
      if (this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    getButtonState(sw) {
      const state = this.$store.getters.getParameterValue(this.node.index, NODES[this.node.deviceType]['OUTPUT' + (sw.index + 1)].PARAMETER_ID);
      return state === 1 ? 'on' : 'off';
    },
    getButtonAuto(sw) {
      const state = this.$store.getters.getParameterValue(this.node.index, NODES[this.node.deviceType]['LEDSTATE' + (sw.index + 1)].PARAMETER_ID);
      return state === 2 ? 'auto' : '';
    },
    getButtonColorText(sw) {
      const state = this.$store.getters.getParameterValue(this.node.index, NODES[this.node.deviceType]['LEDSTATE' + (sw.index + 1)].PARAMETER_ID);
      switch (state) {
        case 0:
          return '#FF4D4D'; // قرمز
        case 1:
          return '#00AEEF'; // آبی
        case 2:
          return '#9B59B6'; // بنفش
        default:
          return '#CCCCCC'; // پیش‌فرض
      }
    },
    getButtonText(sw) {
      const state = this.$store.getters.getParameterValue(this.node.index, NODES[this.node.deviceType]['LEDSTATE' + (sw.index + 1)].PARAMETER_ID);
      switch (state) {
        case 0:
          return sw.name + ' - ' + this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off;
        case 1:
          return sw.name + ' - ' + this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On;
        case 2:
          return sw.name + ' - ' + this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Auto;
        default:
          return '-';
      }
    },
    setButtonStatus(sw) {
      const ls = NODES[this.node.deviceType]['LEDSTATE' + (sw.index + 1)].PARAMETER_ID;
      const ou = NODES[this.node.deviceType]['OUTPUT' + (sw.index + 1)].PARAMETER_ID;
      const ledState = this.$store.getters.getParameterValue(this.node.index, ls);
      const bothEnable = this.$store.getters.getParameterValue(this.node.index, NODES[this.node.deviceType]['AUTOENABLE' + (sw.index + 1)].PARAMETER_ID);

      if(!this.switchLocked){
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        this.switchLocked = true;
        this.$store.commit('setAppBusy', true);

        const valueOfChange = (ledState + 1) % (2 + bothEnable);
        this.$store.commit('setParameterValue', {nodeIndex: this.node.index, parameterId: ls, parameterValue: valueOfChange});
        this.$store.commit('setParameterValue', {nodeIndex: this.node.index, parameterId: ou, parameterValue: valueOfChange % 2});
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node.uuid,
                actions: [
                  {
                    parameterId: ls,
                    valueOfChange: valueOfChange,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  }
                ]
              },
            ]
          }
        })
        .then( () => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
        })
        .catch( response => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
        })
        .finally( () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        });
      }
    },
  },
}
</script>

<style scoped>
.AutoThreewaySwitchWidget-wrapper-switch {
  width: 90%;
  margin: auto;
  padding-top: 10px;
}

.AutoThreewaySwitchWidget-output-wrapper {
  margin-bottom: 20px;
}

.AutoThreewaySwitchWidget-wrapper-switch .SingleSwitchGeneral {
  width: 100%;
  text-align: center;
}

.AutoThreewaySwitchWidget-wrapper-text {
  height: 30px;
  line-height: 34px;
  line-break: anywhere;
  font-size: 10px;
}

.status-text {
  cursor: pointer;
  transition: all 0.3s ease;
}
.align-items-center{
  align-items: center;
}
</style>